import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_hero_banner = _resolveComponent("hero-banner")

  return (_ctx.isBannerVisible)
    ? (_openBlock(), _createBlock(_component_hero_banner, {
        key: 0,
        slides: $options.mappedHeroBanners,
        "is-initialized": _ctx.isInitialized
      }, null, 8 /* PROPS */, ["slides", "is-initialized"]))
    : _createCommentVNode("v-if", true)
}